<div class="upload-modal">
  <div class="upload-modal__header">
    <div class="upload-modal__heading">
      <h5 class="upload-modal__title">
        <i class="fa-solid fa-layer-group mr-2"></i>
        Manage Ad Images
      </h5>
      <p class="upload-modal__subtitle">
        Add multiple image rows before publishing to the map.
      </p>
    </div>
    <div class="upload-modal__location" *ngIf="topText">
      <i class="fas fa-location-dot"></i>
      <span>{{ topText }}</span>
    </div>
    <button class="upload-modal__close" (click)="cancelModal()">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>

  <div class="upload-modal__body">
    <div class="upload-board">
      <h6 class="upload-board__title">Current Row</h6>
        <div class="upload-board__card">
          @if (convertedImageToShow) {
            <div class="editor-preview">
              @if (!currentCropInformationToBeSaved || showCropper) {
                <img
                  [src]="convertedImageToShow"
                  #imageToBeCropped
                  (click)="commonService.clickButton(fileUploadId)"
                />
              }
              @else {
                <app-cropped-image
                  [imgSrc]="convertedImageToShow"
                  class="w-100"
                  [cropInformation]="currentCropInformationToBeSaved"
                ></app-cropped-image>
              }
              <div
                [class.d-none]="!showCropper"
                (pointerdown)="cropperDragStart($event)"
                (pointermove)="cropperDragContinue($event)"
                (pointerup)="cropperDragEnd()"
                class="cropper-overlay"
                #cropper
              ></div>

              <div class="editor-fab" *ngIf="!showCropper && convertedImageToShow">
                <button class="t-btn" (click)="addRotateDegree(90)">
                  <i class="fa fa-sync-alt"></i>
                </button>
                <button class="t-btn" (click)="showCropper = true">
                  <i class="fa-solid fa-scissors"></i>
                </button>
                <button
                  class="t-btn"
                  (click)="showCropper = false; convertedImageToShow = null; imageToUpload = null"
                >
                  <i class="fa fa-x"></i>
                </button>
              </div>
            </div>
          } @else {
            <div class="editor-empty">
              <i class="fa-solid fa-image"></i>
              <p>Select an image to get started</p>
              <div class="editor-empty__actions">
                <button class="upload-entry" (click)="commonService.clickButton(fileUploadId)">
                  <span class="upload-entry__icon">
                    <i class="fa-solid fa-upload"></i>
                  </span>
                  <span class="upload-entry__text">
                    <strong>Upload from your device</strong>
                    <small>Supports JPG, PNG up to 10MB</small>
                  </span>
                </button>
                <button class="upload-entry d-lg-none" (click)="commonService.clickButton(cameraUploadId)">
                  <span class="upload-entry__icon">
                    <i class="fa-solid fa-camera"></i>
                  </span>
                  <span class="upload-entry__text">
                    <strong>Use camera</strong>
                    <small>Capture instantly</small>
                  </span>
                </button>
              </div>
            </div>
          }
        </div>

        <div class="editor-progress" *ngIf="uploadProgress">
          <div class="editor-progress__label">
            Uploading... {{ uploadProgress }}%
          </div>
          <div class="editor-progress__bar">
            <div class="editor-progress__bar-fill" [style.width.%]="uploadProgress"></div>
          </div>
        </div>

      <input
        [(ngModel)]="currentUploadCaption"
        type="text"
        placeholder="Caption (optional)"
        class="caption-input"
      />

        <div class="editor-actions" *ngIf="convertedImageToShow">
          <button class="btn btn-outline-primary" (click)="commonService.clickButton(fileUploadId)">
            <i class="fa-solid fa-image me-1"></i>
            Replace Image
          </button>
          <button class="btn btn-outline-secondary" (click)="showCropper = !showCropper">
            <i class="fa-solid fa-scissors me-1"></i>
            {{ showCropper ? 'Hide Cropper' : 'Adjust Crop' }}
          </button>
        </div>

        <button
          class="my-button-3 add-image-btn"
          (click)="addRow()"
          [disabled]="!canQueueCurrentImage"
        >
          <i class="fa-solid fa-plus me-1"></i>
          Add Image
        </button>
    </div>

    <div class="upload-queue">
      <div class="upload-queue__header">
        <div>
          <h6>Queued Rows</h6>
          <p>{{ queuedImagesCount ? 'Ready to upload' : 'Add rows to build your queue' }}</p>
        </div>
        <span class="upload-queue__badge">{{ queuedImagesCount }}</span>
      </div>

      <div class="upload-queue__content" *ngIf="uploadQueue.length; else emptyQueue">
        <div class="queue-card" *ngFor="let queued of uploadQueue; let i = index">
          <div class="queue-card__preview">
            <img *ngIf="queued.preview" [src]="queued.preview" />
            <div *ngIf="!queued.preview" class="queue-card__placeholder">
              <i class="fa-solid fa-image"></i>
            </div>
          </div>
          <div class="queue-card__body">
            <div class="queue-card__title">Row {{ i + 1 }}</div>
            <div class="queue-card__caption">
              {{ queued.caption || 'No caption added' }}
            </div>
          </div>
          <button class="queue-card__remove" (click)="removeQueuedImage(i)">
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>
      <ng-template #emptyQueue>
        <div class="upload-queue__empty">
          <i class="fa-solid fa-layer-group"></i>
          <p>Your queued rows will appear here.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <div class="upload-modal__footer">
    <button class="my-button-3" (click)="signalUploadImage()" [disabled]="!hasImagesReady">
      <i class="fa-solid fa-cloud-upload-alt me-1"></i>
      Upload {{ queuedImagesCount + (imageToUpload ? 1 : 0) || '' }}
    </button>
  </div>

  <input
    type="file"
    accept="image/*"
    (change)="uploadImageChanged($event)"
    [id]="cameraUploadId"
    capture="environment"
    class="d-none"
  />
  <input
    type="file"
    accept="image/*"
    (change)="uploadImageChanged($event)"
    [id]="fileUploadId"
    class="d-none"
  />
</div>
